import { useState } from "react";
import {
  Button,
  Box,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import { UseBrand } from "./UseBrand";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import CompanyAutoComplete from "../company/CompanyAutoComplete";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddBrand() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { validate, addBrand } = UseBrand();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const Grades = [1, 2, 3];
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
    description: undefined,
    website: undefined,
    graid: 3,
    companyID: undefined,
    metaDescription: undefined,
  });

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
    graid: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/brands" },
          { name: "برند جدید", url: "/brands/addbrand" },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.website ? state.website : ""}
              label="وبسایت "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, website: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <CompanyAutoComplete
              validation={errorState.companyID}
              setter={setState}
              lvl1State={state}
              selectedCompanyID={state.companyID}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <Autocomplete
              size="small"
              value={state.graid ? state.graid : undefined}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({
                    ...state,
                    graid: Number(newValue),
                  });
                } else {
                  setState({
                    ...state,
                    graid: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              sx={{ width: "80%" }}
              getOptionLabel={(option) => option.toString()}
              fullWidth
              options={Grades}
              renderInput={(params) => (
                <TextField
                  error={errorState.graid}
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="رتبه"
                />
              )}
            />
          </Box>
          <Box gridColumn="span 10"></Box>
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
              توضیحات :
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              data={state.description ? state.description : ""}
              style={{ p: "100px", width: "100%" }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setState({ ...state, description: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "500px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
              توضیحات متا :
            </Typography>
            <TextField
              fullWidth
              value={state.metaDescription ? state.metaDescription : ""}
              multiline
              maxRows={5}
              onChange={(evt) => {
                if (evt.target.value.length < 151) {
                  setState({ ...state, metaDescription: evt.target.value });
                  return;
                } else {
                  setState({
                    ...state,
                    metaDescription: state.metaDescription,
                  });
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addBrand(state, () => {
                    navigate("/brands", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/brands", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
